// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackagePageV2MetadataQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanPackagePageV2MetadataQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, name: string } };


export const PlanPackagePageV2MetadataDocument = gql`
    query PlanPackagePageV2Metadata($id: ID!, $versionId: ID) {
  planPackage(id: $id, versionId: $versionId) {
    id
    name
  }
}
    `;

/**
 * __usePlanPackagePageV2MetadataQuery__
 *
 * To run a query within a React component, call `usePlanPackagePageV2MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackagePageV2MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackagePageV2MetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackagePageV2MetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables> & ({ variables: PlanPackagePageV2MetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>(PlanPackagePageV2MetadataDocument, options);
      }
export function usePlanPackagePageV2MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>(PlanPackagePageV2MetadataDocument, options);
        }
// @ts-ignore
export function usePlanPackagePageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>;
export function usePlanPackagePageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackagePageV2MetadataQuery | undefined, PlanPackagePageV2MetadataQueryVariables>;
export function usePlanPackagePageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>(PlanPackagePageV2MetadataDocument, options);
        }
export type PlanPackagePageV2MetadataQueryHookResult = ReturnType<typeof usePlanPackagePageV2MetadataQuery>;
export type PlanPackagePageV2MetadataLazyQueryHookResult = ReturnType<typeof usePlanPackagePageV2MetadataLazyQuery>;
export type PlanPackagePageV2MetadataSuspenseQueryHookResult = ReturnType<typeof usePlanPackagePageV2MetadataSuspenseQuery>;
export type PlanPackagePageV2MetadataQueryResult = ApolloReactCommon.QueryResult<PlanPackagePageV2MetadataQuery, PlanPackagePageV2MetadataQueryVariables>;